module.exports = __webpack_public_path__ + "components/flag/static/square/md-6a2f87f1831ee439b681ef215e0b7355.svg";